module.exports = __webpack_public_path__ + "static/media/article-blog-img1.5d34b2b0.png";